export default "__VITE_ASSET__ehJFlq$7__"